import React, { useState, useEffect } from "react";
import "./Financials.css";
import * as FeatherIcon from "react-feather";
import MicroChart from "../../../HtmlElements/MicroChart";

export default function Ratios({ records = [], requiredValue }) {
  if (!records || Object.keys(records).length === 0) {
    //  return <div></div>;
  }

  const ratios_data = {
    IQ_RETURN_ASSETS: "Return on Assets %",
    IQ_RETURN_CAPITAL: "Return on Capital %",
    IQ_RETURN_EQUITY: "Return on Equity %",
    IQ_RETURN_COMMON_EQUITY: "Return on Common Equity %",
    IQ_GROSS_MARGIN: "Gross Margin %",
    IQ_EBITDA_MARGIN: "EBITDA Margin %",
    IQ_EBITA_MARGIN: "EBITA Margin%",
    IQ_EBIT_MARGIN: "EBIT Margin%",
    IQ_NI_MARGIN: "Net Income Margin %",
    IQ_ASSET_TURNS: "Total Asset Turnover",
    IQ_CURRENT_RATIO: "Current Ratio",
    IQ_QUICK_RATIO: "Quick Ratio",
    IQ_TOTAL_DEBT_EQUITY: "Total Debt/Equity",
    IQ_TOTAL_DEBT_CAPITAL: "Total Debt/Capital",
    IQ_TOTAL_LIAB_TOTAL_ASSETS: "Total Liabilities/Total Assets",
    IQ_TOTAL_DEBT_EBITDA: "Total Debt/EBITDA",
    IQ_TOTAL_REV_5YR_ANN_CAGR:
      "Total Revenue Growth Over Prior Year %, Growth Over Five Years %",
    IQ_GP_5YR_ANN_CAGR:
      "Gross Profit Growth Over Prior Year %, Growth Over Five Years %",
    IQ_EBITDA_5YR_ANN_CAGR:
      "EBITDA Growth Over Prior Year %, Growth Over Five Years %",
    IQ_EBITA_5YR_ANN_CAGR:
      "EBITA Growth Over Prior Year %, Growth Over Five Years %",
    IQ_EBIT_5YR_ANN_CAGR:
      "EBIT Growth Over Prior Year %, Growth Over Five Years %",
    IQ_NI_5YR_ANN_CAGR:
      "Net Income Growth Over Prior Year %, Growth Over Five Years %",
    IQ_TOTAL_ASSETS_5YR_ANN_CAGR:
      "Total Assets Growth Over Prior Year %, Growth Over Five Years %",
  };

  const recordsArray = Array.isArray(records) ? records : [];
  const latestYears = Array.from(
    new Set(
      recordsArray.flatMap((record) => record.data.map((item) => item.year))
    )
  )
    .sort((a, b) => b - a)
    .slice(0, 5)
    .reverse();

  return (
    <>
      {
        <div className="col-md-12 mb-2 mt-2">
          <div className="custom_card_block">
            <div className="quarterly_result_block">
              <div className="head_top">
                <h5 className="main_head">Ratios</h5>
                {/* <p className='main_head_para'>Consolidated Figures in $Mn  */}
                <p className="main_head_para"></p>
                {/* / <span className='blue_text'>View Standalone</span> */}
                {/* </p> */}
              </div>
              <div className="quater_table_block">
                {latestYears.length <= 0 && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="alert alert-warning" role="alert">
                        Complete financials are only available in paid version.
                      </div>
                    </div>
                  </div>
                )}

                {latestYears.length > 0 && (
                  <div className="table-responsive custom_table_qut">
                    <table className="quater_table custom-resizable-table">
                      <thead className="quater_table_thead">
                      <tr className="quater_table_tr custom-resizable-table-header ">
                          {/* <th className="quater_table_th"></th>
                        <th className="quater_table_th">2019</th>
                        <th className="quater_table_th">2020</th>
                        <th className="quater_table_th">2021</th>
                        <th className="quater_table_th">2022</th>
                        <th className="quater_table_th">2023</th>
                        <th className="quater_table_th text-center" style={{width: '110px'}}>5-Year Trend</th> */}
                          <th className="quater_table_th"></th>
                          {latestYears.map((year) => (
                            <th key={year} className="quater_table_th">
                             <div className="custom-resizable-table-th-content"> {year}</div>
                            </th>
                          ))}
                          <th
                            className="quater_table_th text-center"
                            style={{ width: "110px" }}
                          >
                             <div className="custom-resizable-table-th-content">5-Year Trend</div>
                          </th>
                        </tr>
                      </thead>

                      <tbody className="quater_table_tbody">
                        {Object.entries(ratios_data).map(([key, label]) => {
                          const record = records.find(
                            (item) => item._id === key
                          );
                          if (!record) return null;

                          const yearDataMap = Object.fromEntries(
                            record.data.map((item) => [item.year, item.value])
                          );
                          const chartData = latestYears.map((year) => ({
                            category: year,
                            value: parseFloat(yearDataMap[year] || 0),
                          }));

                          return (
                            <tr className="quater_table_tr dimension-row cursor-pointer gtr-row " key={key}>
                            <td className="quater_table_td_left gtr-cell"><div className="gtr-cell-content-container">{label}</div></td>
                              {latestYears.map((year) => (
                                <td key={year} className="quater_table_td gtr-cell">
                                  <div className="gtr-cell-content-container">
                                  {yearDataMap[year] < 0 ? (
                                    <span style={{ color: "red" }}>
                                      {requiredValue(
                                        yearDataMap[year],
                                        "ratios"
                                      )}
                                    </span>
                                  ) : (
                                    requiredValue(yearDataMap[year])
                                  )}
                                  </div>
                                </td>
                              ))}
                                <td className="quater_table_td text-center gtr-cell">
                                <MicroChart data={chartData} chartType="bar" />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
}
